<script setup lang="ts">
  import TheToast from '@/components/the-toast.vue'
  import { useInitApp } from './models/app'
  import { useAuthStore } from './stores/auth'

  const auth = useAuthStore()

  const { init } = useInitApp()
  init()
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition
      name="fade"
      mode="out-in">
      <component
        :is="Component"
        v-if="auth.authenticated >= 0"
        v-bind="$attrs" />

      <div
        v-else
        class="fixed inset-0 flex-center">
        <fa-icon
          class="animate-spin text-8xl text-primary-500"
          icon="i-fas-spinner-third" />
      </div>
    </transition>
  </router-view>

  <the-toast />
</template>
